import { Button, Column, Td, Tr } from 'hatch-components';
import styled from 'styled-components';

export const StyledTr = styled(Tr)(({ theme: { colors } }) => ({
  '&:hover': {
    td: {
      background: colors.white,
    },
  },
  borderBottom: 0,
}));

export const StyledTd = styled(Td)(() => ({
  padding: 0,
}));

export const StyledTeamEmptyStateWrapper = styled(Column)(
  ({ theme: { spacing } }) => ({
    alignItems: 'center',
    justifyContent: 'center',
    padding: `${spacing.xxl} 0 ${spacing.lg}`,
  }),
);

export const StyledTeamEmptyStateText = styled.p(
  ({
    theme: {
      spacing,
      colors,
      font,
      responsive: { mobile },
    },
  }) => ({
    color: colors.darkGrey,
    flexShrink: 0,
    fontSize: font.size.sm,
    lineHeight: font.lineHeight.sm,
    [mobile]: {
      textAlign: 'left',
    },
    paddingBottom: spacing.md,
    textAlign: 'center',
    width: '100%',
  }),
);

export const StyledButton = styled(Button)(({ theme: { font } }) => ({
  flexShrink: 0,
  fontSize: font.size.sm,
  height: 48,
}));
